import { ethers } from 'ethers'

export const getRandomEthAddress = () => {
  const wallet = ethers.Wallet.createRandom()
  return wallet.address
}
